import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "homes" }

import request from '@/utils/request'
    import {ref,reactive} from "vue"
    
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

    let list = ref([])
    let query = reactive({
        title:"",
        content:""
    })
    function add() {

        let params = new FormData()
        params.append("title",query.title)
        params.append("content",query.content)
        request({
            url: '/feedback/add',
            method: 'post',
            data:params
        }).then(data=>{
            query.title = ""
            query.content = ""
            getList()
        })
    }
    function handle_delete(id) {
        request({
            url: '/feedback/del/'+id,
            method: 'post',
        }).then(data=>{
            getList()
        })
    }
    function getList(){
        request({
            url: '/feedback/list',
            method: 'get',
        }).then(data=>{
            list.value = data.data
            console.log(data)
        })
    }
    getList()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("span", null, "欢迎使用台铃智能管理系统v2.0", -1)
  ])))
}
}

})